import React from "react";

export default function Terms() {
    return (
        <div data-testid="terms-page" className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-24">
            <span className="overline">Legal</span>
            <h1 className="font-serif text-4xl sm:text-5xl font-bold mt-4 text-[#0A192F]">
                Terms & Conditions
            </h1>
            <div className="mt-10 space-y-6 text-slate-700 leading-relaxed">
                <p>
                    These Terms govern your use of the Hopewell Consulting LLC
                    website and the consulting services described herein.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Use of site
                </h2>
                <p>
                    Content on this site is provided for informational purposes.
                    It does not constitute legal, financial, tax, or
                    professional advice. Engagement letters issued by Hopewell
                    Consulting govern actual consulting services.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Intellectual property
                </h2>
                <p>
                    All content, logos, and brand marks are property of
                    Hopewell Consulting LLC unless otherwise noted.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Limitations of liability
                </h2>
                <p>
                    To the maximum extent permitted by law, Hopewell Consulting
                    is not liable for indirect, incidental, or consequential
                    damages arising from use of this site or reliance on its
                    content.
                </p>
                <h2 className="font-serif text-2xl font-bold text-[#0A192F] pt-4">
                    Governing law
                </h2>
                <p>
                    These Terms are governed by the laws of the State of
                    Tennessee.
                </p>
                <p className="text-sm text-slate-500 pt-6">
                    Last updated: {new Date().toLocaleDateString()}
                </p>
            </div>
        </div>
    );
}
